(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const mobile = window.matchMedia('(max-width: 749px)');
  const sectionsSelector = '.hc-new-arrivals,.hc-best-sellers,.hc-tv,.hc-ugc';
  const cardsSelector = '.hc-new-card,.hc-best-card,.hc-tv__card,.hc-ugc__card';

  function addGlow(card) {
    if (card.querySelector(':scope > .hc-motion-glow')) return;
    const glow = document.createElement('span');
    glow.className = 'hc-motion-glow';
    glow.setAttribute('aria-hidden', 'true');
    card.appendChild(glow);

    card.addEventListener('pointermove', (event) => {
      if (!finePointer.matches || reduceMotion.matches) return;
      const rect = card.getBoundingClientRect();
      card.style.setProperty('--hc-pointer-x', event.clientX - rect.left + 'px');
      card.style.setProperty('--hc-pointer-y', event.clientY - rect.top + 'px');
    }, { passive: true });
  }

  function addMagneticMotion(element) {
    if (element.dataset.hcMagnetic === 'true') return;
    element.dataset.hcMagnetic = 'true';
    element.classList.add('hc-motion-magnetic');

    element.addEventListener('pointermove', (event) => {
      if (!finePointer.matches || reduceMotion.matches) return;
      const rect = element.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width - .5) * 8;
      const y = ((event.clientY - rect.top) / rect.height - .5) * 6;
      element.style.setProperty('--hc-magnetic-x', x.toFixed(2) + 'px');
      element.style.setProperty('--hc-magnetic-y', y.toFixed(2) + 'px');
    }, { passive: true });

    element.addEventListener('pointerleave', () => {
      element.style.setProperty('--hc-magnetic-x', '0px');
      element.style.setProperty('--hc-magnetic-y', '0px');
    }, { passive: true });
  }

  function createActiveRail(rail, cardSelector) {
    if (!rail || rail.dataset.hcMotionRail === 'true') return;
    rail.dataset.hcMotionRail = 'true';
    let frame = 0;

    const update = () => {
      frame = 0;
      const cards = [...rail.querySelectorAll(cardSelector)];
      if (!cards.length) return;
      const railRect = rail.getBoundingClientRect();
      const center = railRect.left + railRect.width / 2;
      let active = cards[0];
      let distance = Infinity;
      cards.forEach((card) => {
        const rect = card.getBoundingClientRect();
        const current = Math.abs(rect.left + rect.width / 2 - center);
        if (current < distance) {
          distance = current;
          active = card;
        }
      });
      cards.forEach((card) => card.classList.toggle('is-motion-active', card === active));
    };

    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    rail.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }

  function pauseOffscreenVideos() {
    const videos = document.querySelectorAll('.hc-tv video');
    if (!videos.length || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting || entry.intersectionRatio < .55 || reduceMotion.matches) {
          video.pause();
        } else {
          video.play().catch(() => {});
        }
      });
    }, { threshold: [0, .55, 1] });
    videos.forEach((video) => observer.observe(video));
  }

  function init(root = document) {
    const sections = root.querySelectorAll(sectionsSelector);
    const revealObserver = 'IntersectionObserver' in window && !reduceMotion.matches
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('hc-in-view');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: .1 })
      : null;

    sections.forEach((section) => {
      if (section.dataset.hcMotionReady === 'true') return;
      section.dataset.hcMotionReady = 'true';
      const cards = section.querySelectorAll(cardsSelector);
      cards.forEach((card, index) => {
        card.style.setProperty('--hc-delay', Math.min(index * 70, 280) + 'ms');
        addGlow(card);
        addMagneticMotion(card);
      });

      if (revealObserver) {
        section.classList.add('hc-motion-managed');
        revealObserver.observe(section);
      } else {
        section.classList.add('hc-in-view');
      }
    });

    if (mobile.matches) {
      root.querySelectorAll('.hc-new-arrivals__grid').forEach((rail) => createActiveRail(rail, '.hc-new-card'));
      root.querySelectorAll('.hc-best-sellers__grid').forEach((rail) => createActiveRail(rail, '.hc-best-card'));
      root.querySelectorAll('.hc-tv__track').forEach((rail) => createActiveRail(rail, '.hc-tv__card'));
      root.querySelectorAll('.hc-ugc__rail').forEach((rail) => createActiveRail(rail, '.hc-ugc__card'));
    }
    pauseOffscreenVideos();
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
